import data from './catalog-data.json';

// Static, bundled catalog for both Nespresso lines (Original + Vertuo),
// snapshotted from the backend seed. No API fetch at runtime.
// Images ship with the app under public/images/{original,vertuo}/.
function buildCatalog(collections, type) {
  return collections.map((col, ci) => ({
    id: `${type}-${ci}`,
    name: col.name,
    description: col.description || '',
    size: col.size || '',
    items: col.items.map((it, ii) => ({
      id: `${type}-${ci}-${ii}`,
      name: it.name,
      intensity: it.intensity,
      description: it.description,
      price: it.price,
      size: it.size || col.size || '',
      imgUrl: it.imgUrl, // e.g. /images/original/Scuro.png
      collection: col.name,
      capsuleType: type,
      inStock: it.inStock,
    })),
  }));
}

export default {
  original: buildCatalog(data.original, 'original'),
  vertuo: buildCatalog(data.vertuo, 'vertuo'),
};
